module.exports = __webpack_public_path__ + "img/MAG-3.ec608500.gif";